export const tokenAddresses = {
  EUL: "0xE9C43e09C5FA733bCC2aEAa96063A4a60147AA09",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0x1b0e3Da51b2517E09aE74CD31b708e46B9158E8b",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
